import { Loader } from '@googlemaps/js-api-loader';

function showMarkerCard(markerView) {
    if (!markerView.content.classList.contains("highlight")) {
        markerView.content.classList.add("highlight");
        markerView.zIndex = 1;

        // NOTE: hack, not terrible to use set timeout but cannot know in advance when the gmp will be fully loaded
        setTimeout(function () {
            let map = document.querySelector('.maier-wrapper-google-section-shop .maier-section-shop-map');

            let markerPosition = markerView.getBoundingClientRect();

            if (markerPosition.y - markerView.content.offsetHeight < map.offsetTop) {
                markerView.content.style.bottom = null;
                markerView.content.style.top = '0px';
            }

            if (markerPosition.y + markerView.content.offsetHeight > map.offsetTop + map.offsetHeight) {
                markerView.content.style.bottom = '0px'
                markerView.content.style.top = null;
            }
        }, 300);
    }

    let closeButton = markerView.content.querySelector('.close');
    if (!closeButton.hasAttribute('initialized')) {
        closeButton.setAttribute('initialized', null);
        closeButton.addEventListener('click', function (e) {
            hideMarkerCard(markerView);
            e.stopPropagation();
        })
    }
}

function hideMarkerCard(markerView) {
    if (markerView.content.classList.contains("highlight")) {
        markerView.content.classList.remove("highlight");
        markerView.zIndex = null;
    }
}

function buildContent(marker) {
    const content = document.createElement("div");

    content.classList.add("maier-section-map-marker-card");
    content.innerHTML = `
        <div class="close">&times;</div>
        <div class="logo">
            <picture class="maier-section-map-shops-list-item-media">
                ${
                    marker.media.mediaBreakpoints.length > 0 ? `<source srcset="${marker.media.mediaBreakpoints[0].media.url}" media="(max-width: ${marker.media.mediaBreakpoints[0].maxWidth}px)">` : ''
                }
                <img src="${marker.media.url}">
            </picture>
        </div>
        <div class="card">
            <div class="card-banner">
                <picture class="maier-section-map-shops-list-item-media">
                    ${
                        marker.banner_media.mediaBreakpoints.length > 0 ? `<source srcset="${marker.banner_media.mediaBreakpoints[0].media.url}" media="(max-width: ${marker.banner_media.mediaBreakpoints[0].maxWidth}px)">` : ''
                    }
                    <img src="${marker.banner_media.url}">
                </picture>
            </div>
            <div class="card-information">
                <div class="card-information-name">${marker.name}</div>
                <div class="card-information-address">${marker.address}</div>
                <a href="tel:${marker.phone_number}" class="card-information-phone-number">${marker.phone_number}</a>
                <button class="maier-button maier-button-primary card-information-action-booking" data-booking-configuration="${marker.booking_button.configuration}">${marker.booking_button.label}</button>
                <a class="maier-link maier-link-primary card-information-action" href="${marker.link.href}">${marker.link.label}</a>
            </div>
        </div>
        `;

    return content;
}

function initGoogleMap(mapElement) {
    if (null === mapElement) {
        return;
    }

    const loader = new Loader({
        apiKey: mapElement.getAttribute('data-google-map-api-key'),
        version: "weekly",
        libraries: ["maps", "marker"]
    });

    loader
        .load()
        .then((google) => {
            let map = new google.maps.Map(mapElement, {
                mapId: "4504f8b37365c3d0",
                center: {
                    lat: parseFloat(mapElement.getAttribute('data-latitude')),
                    lng: parseFloat(mapElement.getAttribute('data-longitude'))
                },
                zoom: parseInt(mapElement.getAttribute('data-zoom'))
            });

            let marker = JSON.parse(mapElement.getAttribute('data-marker'));
            const AdvancedMarkerElement = new google.maps.marker.AdvancedMarkerElement({
                map,
                content: buildContent(marker),
                position: {
                    lat: parseFloat(marker.latitude),
                    lng: parseFloat(marker.longitude)
                },
                title: marker.title,
            });

            AdvancedMarkerElement.addListener("gmp-click", () => {
                showMarkerCard(AdvancedMarkerElement);
            });

            let mainContainer = document.querySelector('.maier-wrapper-google-section-shop .maier-section-shop-main');

            // resize automatically based on main container
            mapElement.style.paddingTop = 0;
            mapElement.style.height = mainContainer.offsetHeight + 'px';
            window.addEventListener("resize", (event) => {
                mapElement.style.height = mainContainer.offsetHeight + 'px';
            });
        })
    ;
}

function setupGoogleMap() {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            initGoogleMap(document.querySelector('.maier-wrapper-google-section-shop .maier-section-shop-map'));
        })
    })
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupGoogleMap);
} else {
    setupGoogleMap();
}